import { Col, Form, InputNumber, Row } from "antd"
import { useTranslation } from "react-i18next"
import { Card } from "ui/Card"
import { Text } from "ui/Typography"

const getMinGuestsValidator = (getFieldValue, t) => ({
  validator(_, value) {
    const maxGuests = getFieldValue("max_guests")
    if (typeof value === "number" && typeof maxGuests === "number" && value > maxGuests) {
      return Promise.reject(new Error(t("experiences.details.errors.min_less_than_max")))
    }
    return Promise.resolve()
  }
})

const getMaxGuestsValidator = (getFieldValue, t) => ({
  validator(_, value) {
    const minGuests = getFieldValue("min_guests")
    if (typeof value === "number" && typeof minGuests === "number" && value < minGuests) {
      return Promise.reject(new Error(t("experiences.details.errors.max_greater_than")))
    }
    return Promise.resolve()
  }
})

const handleNumericKeyDown = (e) => {
  if (["Backspace", "Tab", "ArrowLeft", "ArrowRight", "Delete", "Home", "End"].includes(e.key)) {
    return
  }
  if (!/^\d$/.test(e.key)) {
    e.preventDefault()
  }
}

export const GuestDetails = () => {
  const [t] = useTranslation()

  return (
    <Card title={t("experiences.details.guest_details")} className="mb-3xl">
      <Text type="subtitle" size="lg" fw="500" className="block mb-xxl">
        {t("experiences.details.number_guest_details")}
      </Text>

      <Row className="mb-l" gutter={16}>
        <Col span={12}>
          <Form.Item
            name="min_guests"
            label={t("experiences.details.labels.minimum")}
            rules={[
              { required: true, message: t("experiences.details.errors.minimum_guests") },
              ({ getFieldValue }) => getMinGuestsValidator(getFieldValue, t)
            ]}
          >
            <InputNumber
              size="large"
              placeholder="1"
              min={1}
              style={{ width: "100%" }}
              onKeyDown={handleNumericKeyDown}
            />
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item
            name="max_guests"
            label={t("experiences.details.labels.maximum")}
            rules={[
              { required: true, message: t("experiences.details.errors.maximum_guests") },
              ({ getFieldValue }) => getMaxGuestsValidator(getFieldValue, t)
            ]}
          >
            <InputNumber
              size="large"
              placeholder="10"
              min={1}
              style={{ width: "100%" }}
              onKeyDown={handleNumericKeyDown}
            />
          </Form.Item>
        </Col>
      </Row>
    </Card>
  )
}
